// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3w4ks","icon":"styles_icon__1o-St"};